let videoID = "XmY6tgIm9kY"


export default { videoID }